/**
 * Turn an API error into something an editor can act on.
 *
 * Feathers validation errors carry their detail in a hoisted `errors` key, not
 * in `message` and not in `data`: `new BadRequest('Address validation failed',
 * { errors: [...] })` produces `error.errors`, while `error.data` is `{}`. A
 * handler that shows only `message`, or replaces it with a generic string, tells
 * the editor that something failed and never which field.
 *
 * That cost real time on 2026-09-26. A listing carrying a partial address could
 * not be saved, and the admin reported "Something went wrong" while the API was
 * returning three specific field errors naming country, street and city.
 */
export default function apiErrorMessage(error, fallback = 'Something went wrong.') {
  if (!error) return fallback;

  const detail = Array.isArray(error.errors)
    ? error.errors.filter(Boolean)
    // Some validators return an object keyed by field rather than an array.
    : Object.values(error.errors || {}).filter((v) => typeof v === 'string');

  const head = error.message || fallback;
  return detail.length ? `${head}: ${detail.join('. ')}` : head;
}
